import * as React from 'react';
import './Admin.less';
import { Form, Input, Button, Select, Divider, message, Spin, Checkbox, Tooltip, Row, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import TranslationDTO from 'src/models/generic/TranslationDTO';
import AddAcademicStandardFrameworkDTO from 'src/models/academic/AddAcademicStandardFrameworkDTO';
import UpdateAcademicStandardFrameworkDTO from 'src/models/academic/UpdateAcademicStandardFrameworkDTO';
import AcademicApiController from 'src/api/AcademicApiController';


interface RouteParams {
    id: string;
}

interface AddEditAcademicStandardFrameworkProps extends PageProps<RouteParams>, LocalizeContextProps { }

interface AddEditAcademicStandardFrameworkState {
    loading: boolean;
    isSubmitting: boolean;
    currentAcademicStandardFramework: UpdateAcademicStandardFrameworkDTO;
    redirect: boolean;
}

interface AcademicStandardFrameworkFormProps {
    currentAcademicStandardFramework: UpdateAcademicStandardFrameworkDTO;
    translate: (id: any) => any;
    onChange: (changedFields: any[]) => void;
}

// Form
let AcademicStandardFrameworkForm = Form.create({
    onFieldsChange(props: AcademicStandardFrameworkFormProps, changedFields: any[]) {
        props.onChange(changedFields);
    }
})(class extends React.Component<AcademicStandardFrameworkFormProps & FormComponentProps> {
    constructor(props: AcademicStandardFrameworkFormProps & FormComponentProps) {
        super(props);
    }

    private renderStandardFormItem(translationId: string, id: string, initialValue, inputType, visible: boolean = true, required: boolean = true) {
        let translatedLabel = this.props.translate(translationId);

        if (visible) {
            return (
                <Form.Item label={translatedLabel}>
                    {this.props.form.getFieldDecorator(id, {
                        initialValue: initialValue,
                        rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
                    })(inputType)}
                </Form.Item>
            );
        }
    }
    render() {
        return (
            <Row>
                <Col span={12}>
                    <Form className="admin-form">
                        {this.renderStandardFormItem(
                            "admin.addEditAcademicStandardFramework.formItem1",
                            "framework",
                            this.props.currentAcademicStandardFramework.framework,
                            <Input autoComplete="off" />
                        )}
                    </Form>
                </Col>
            </Row>
        );
    }
});

class AddEditAcademicStandardFramework extends React.Component<AddEditAcademicStandardFrameworkProps, AddEditAcademicStandardFrameworkState> {
    private formRef: React.Component<FormComponentProps>;

    constructor(props: AddEditAcademicStandardFrameworkProps) {
        super(props);
        bindAllOfThis(this, AddEditAcademicStandardFramework.prototype);

        let academicStandardFrameworkId = parseInt(this.props.match.params.id, 10);

        let currentAcademicStandardFramework: UpdateAcademicStandardFrameworkDTO = {
            academicStandardFrameworkId: academicStandardFrameworkId,
            framework: ""
        };

        this.state = {
            loading: true,
            redirect: false,
            isSubmitting: false,
            currentAcademicStandardFramework: currentAcademicStandardFramework
        };
    }

    componentWillMount() {
        this.fillForm();
    }

    private fillForm(): void {
        if (this.state.currentAcademicStandardFramework.academicStandardFrameworkId) {
            AcademicApiController.getAcademicStandardFramework(this.state.currentAcademicStandardFramework.academicStandardFrameworkId).then((result) => {
                this.setState({
                    loading: false,
                    currentAcademicStandardFramework: result.data
                });
            }).catch(e => {
                message.error(this.props.translate('admin.addEditAcademicStandardFramework.messageRetrieveError'));
            });
        } else {
            this.setState({
                loading: false
            });
        }
    }

    private handleInputChange(changedFields: any[]): void {
        let newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                let field: any = changedFields[key];
                newState[key] = field.value;
            }
        }
        this.setState({
            currentAcademicStandardFramework: { ...this.state.currentAcademicStandardFramework, ...newState }
        });
    }

    private addAcademicStandardFramework(): void {
        let addAcademicStandardFrameworkDTO: AddAcademicStandardFrameworkDTO = {
            framework: this.state.currentAcademicStandardFramework.framework
        };

        AcademicApiController.addAcademicStandardFramework(addAcademicStandardFrameworkDTO)
            .then(result => {
                message.success(this.props.translate('admin.addEditAcademicStandardFramework.messageAdd'));
                this.setState({ redirect: true, isSubmitting: false });
            }).catch(e => {
                message.error(this.props.translate('admin.addEditAcademicStandardFramework.messageAddError'));
                this.setState({ isSubmitting: false });
            });
    }

    private updateAcademicStandardFramework(): void {
        AcademicApiController.updateAcademicStandardFramework(this.state.currentAcademicStandardFramework)
            .then(result => {
                message.success(this.props.translate('admin.addEditAcademicStandardFramework.messageUpdate'));
                this.setState({ redirect: true, isSubmitting: false });
            }).catch(e => {
                message.error(this.props.translate('admin.addEditAcademicStandardFramework.messageUpdateError'));
                this.setState({ isSubmitting: false });
            });
    }

    private handleSubmit(e): void {
        e.preventDefault();

        this.formRef.props.form.validateFields((error: any, values: any) => {
            if (!error) {
                this.setState({ isSubmitting: true });
                this.state.currentAcademicStandardFramework.academicStandardFrameworkId ? this.updateAcademicStandardFramework() : this.addAcademicStandardFramework();
            }
        });
    }

    private handleCancel(e): void {
        this.setState({ redirect: true });
    }

    private saveFormRef(formRef: React.Component<FormComponentProps>): void {
        this.formRef = formRef;
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={Routes.ADMIN_ACADEMICS} push />;
        } else if (this.state.loading) {
            return <Spin />;
        }

        let formProps = {
            currentAcademicStandardFramework: this.state.currentAcademicStandardFramework,
            translate: this.props.translate,
            onChange: this.handleInputChange
        } as AcademicStandardFrameworkFormProps ;

        return (
            <div>
                <h2>{this.props.translate('admin.addEditAcademicStandardFramework.addHeader')}</h2>

                <AcademicStandardFrameworkForm wrappedComponentRef={this.saveFormRef} {...formProps} />

                <div>
                    <Button type="primary" onClick={this.handleSubmit} loading={this.state.isSubmitting}>
                        {this.props.translate("admin.common.saveButton")}
                    </Button>
                    <Divider type="vertical" />
                    <Button onClick={this.handleCancel}>
                    {this.props.translate("common.back")}
                    </Button>
                </div>
            </div>
        );
    }
}

export default withLocalize(AddEditAcademicStandardFramework);



// WEBPACK FOOTER //
// ./src/pages/admin/AddEditAcademicStandardFramework.tsx